import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

const MyProgressBar = styled(Box)(() => ({
  background: '#FFE7E7',
  borderRadius: '16px',
  margin: '0 auto 20px',
  width: '290px',
  textAlign: 'center'
}))

const MyDot = styled(Box)(() => ({
  width: '12px',
  height: '12px',
  background: '#FFF2F2',
  margin: '0 1px',
  borderRadius: '50%',
  transition: 'all 0.5s ease',
  display: 'inline-block',
  "&.filled": {
    background: '#E43C3C'
  },
  "&.almost": {
    background: '#FF9999'
  },
}))

function CircularProgressWithLabel(props) {

  let dots = 20;

  return (
    <MyProgressBar>
      {[...Array(dots)].map((item, key) => (
        <MyDot 
          key={key} 
          className={props.value === key ? 'almost' : props.value > key && 'filled'}
        >
          {item}
        </MyDot>
      ))}
    </MyProgressBar>
  );
}

export default function ProgressBarDots(props) {

  const [procent, setProcent] = useState(1);
  const [play, setPlay] = useState(true);

  useEffect(() => {
    if (play) {
      let id = setInterval(() => {
        if (props.done) {
          setProcent(20);
          clearInterval(id);
          setPlay(false);
          props.callBack && props.callBack();
        } else if (procent > 19) {
          clearInterval(id);
          setPlay(false);
          props.callBack && props.callBack();
        } else {
          setProcent(procent + 1)
        }
      }, 275);
      return () => {
        clearInterval(id);
      };
    }
  });

  return <CircularProgressWithLabel
    size={80}
    thickness={2}
    value={procent} />
}